import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Biofarmax";
const SITE_URL = "https://biofarmax.com.br";
const DEFAULT_IMAGE = `${SITE_URL}/assets/biofarmax-logo.png`;
const DEFAULT_DESCRIPTION =
  "Farmácia de manipulação Biofarmax — fórmulas exclusivas em cápsulas, óleos, colágenos, dermocosméticos e suplementos. Atendimento farmacêutico personalizado em Campinas/SP, entrega para todo o Brasil.";

/**
 * Generic SEO component. Adds:
 *  - title / description / keywords
 *  - canonical
 *  - Open Graph + Twitter card
 *  - schema.org JSON-LD (any structured data passed in)
 *
 * Use `<SEO ... jsonLd={obj}>` on every page to provide Google rich data.
 */
export default function SEO({
  title,
  description,
  path = "",
  image,
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const fullTitle = title
    ? `${title} · ${SITE_NAME}`
    : `${SITE_NAME} · Farmácia de Manipulação em Campinas`;
  const desc = description || DEFAULT_DESCRIPTION;
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large" />
      )}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="pt_BR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* Structured data */}
      {jsonLd &&
        (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((item, i) => (
          <script key={i} type="application/ld+json">
            {JSON.stringify(item)}
          </script>
        ))}
    </Helmet>
  );
}

export { SITE_URL, SITE_NAME, DEFAULT_IMAGE };
